// @flow
import { KEY } from './constants'

export const getNotification = (state: Object) => state[KEY].notification
export const getLoading = (state: Object) => state[KEY].loading
